export const TOP_BAR_ITEMS = {
  BACK: 'BACK',
  START_OVER: 'START_OVER',
  BACK_TO_LIVE: 'BACK_TO_LIVE',
  TRACKS: 'TRACKS',
  RELATED_VIDEOS: 'RELATED_VIDEOS',
  INFO_PAGE: 'INFO_PAGE',
};

export const TRACK_KEYS = {
  PREFERRED_AUDIO_TRACK_LANGUAGE: 'preferredAudioTrackLanguage',
  PREFERRED_SUBTITLE_TRACK_LANGUAGE: 'preferredSubtitleTrackLanguage',
};
